<div class="Loading" *ngIf="IsShowLoading == true">
  <div class="loader"></div>
  <label class="loaderlabel">Please wait while Processing....</label>
</div>

<div class="PolicyDashboard">
  <div class="container-fluid">
    <div class="row" style="margin-top: 20px;">
      <div class="col-lg-12 col-md-12 col-xs-12 col-sm-12">
          
            <div style="padding: 20px;">
              <div class="PaymentForm">
                <div class="row" style="display: flex;justify-content:space-between;flex-wrap: wrap;">
                
                  <div class="card Card_Ar cardcancellationdetails col-lg-12 col-md-12 col-sm-12 col-xs-12 glascard claymorphism">
                    <div class="policydetailshead">
                      <h5 class="cancelpolicy">{{'Policy Info' | translate}}</h5>
                    </div>
                    <label class="cardfeild">
                      <span class="lbltext">{{'Policy No'|translate}}:</span>
                      <span class="lbldata policyno" style="color: red;">{{objBindInfoRes.PolicyDetails.PolicyNo}}</span>
                    </label>
                    <label class="cardfeild">
                      <span class="lbltext">{{'Policy Issue Date'|translate}}:</span>
                      <span class="lbldata policyno">{{objBindInfoRes.PolicyDetails.PolicyIssueDate}}</span>
                    </label>
                    <label class="cardfeild">
                      <span class="lbltext">{{'Policy From Date'|translate}}:</span>
                      <span class="lbldata policyno">{{objBindInfoRes.PolicyDetails.PolicyFromDate}}</span>
                    </label>
                    <label class="cardfeild">
                      <span class="lbltext">{{'Policy To Date'|translate}}:</span>
                      <span class="lbldata policyno">{{objBindInfoRes.PolicyDetails.PolicyToDate}}</span>
                    </label>
                    <label class="cardfeild">
                      <span class="lbltext">{{'Insured Name'|translate}}:</span>
                      <span class="lbldata policyno">{{objBindInfoRes.PolicyDetails.Insured_Name}}</span>
                    </label>
                    <label class="cardfeild">
                      <span class="lbltext">{{'Insured IDNo'|translate}}:</span>
                      <span class="lbldata policyno">{{objBindInfoRes.PolicyDetails.Insured_IDNo}}</span>
                    </label>
                    <label class="cardfeild">
                      <span class="lbltext">{{'Insured Email'|translate}}:</span>
                      <span class="lbldata policyno">{{objBindInfoRes.PolicyDetails.Insured_EmailId}}</span>
                    </label>
                    <label class="cardfeild">
                      <span class="lbltext">{{'Insured MobileNo'|translate}}:</span>
                      <span class="lbldata policyno">{{objBindInfoRes.PolicyDetails.Insured_MobileNo}}</span>
                    </label>
                  </div>

                  <!-- <div class="card Card_Ar cardcancellationdetails col-lg-6 col-md-6 col-sm-12 col-xs-12 glascard claymorphism">
                    <div class="policydetailshead">
                      <h5 class="cancelpolicy">{{'Premium Info' | translate}}</h5>
                    </div>
                    <label class="cardfeild">
                      <span class="lbltext">{{'Gross Amount'|translate}}:</span>
                      <span class="lbldata policyno">{{TravelRefundRes.TravelRefund.GrossAmount}}</span>
                    </label>
                    <label class="cardfeild">
                      <span class="lbltext">{{'VAT Amount'|translate}}:</span>
                      <span class="lbldata policyno">{{TravelRefundRes.TravelRefund.VATAmount}}({{TravelRefundRes.TravelRefund.VATPercent}}%)</span>
                    </label>
                    <label class="cardfeild">
                      <span class="lbltext">{{'Total Premium Paid'|translate}}:</span>
                      <span class="lbldata policyno" style="color: red;">{{TravelRefundRes.TravelRefund.PremiumPaid}}</span>
                    </label>

                    <label class="cardfeild">
                      <span style="color: red;font-family: verdana;font-weight: bold;">{{'Refund Details'|translate}}:</span>
                    </label>

                    <label class="cardfeild">
                      <span class="lbltext">{{'Refund Amount'|translate}}:</span>
                      <span class="lbldata policyno">{{TravelRefundRes.TravelRefund.RefundAmount}}</span>
                    </label>
                    <label class="cardfeild">
                      <span class="lbltext">{{'Admin Fee'|translate}}:</span>
                      <span class="lbldata policyno">{{TravelRefundRes.TravelRefund.AdminFee}}</span>
                    </label>
                    <label class="cardfeild">
                      <span class="lbltext">{{'Refund Amount After Admin Fee'|translate}}:</span>
                      <span class="lbldata policyno">{{TravelRefundRes.TravelRefund.RefundAfterAdminFee}}</span>
                    </label>
                    <label class="cardfeild">
                      <span class="lbltext">{{'VAT Refund Amount'|translate}}:</span>
                      <span class="lbldata policyno">{{TravelRefundRes.TravelRefund.RefundVATAmount}}({{TravelRefundRes.TravelRefund.VATPercent}}%)</span>
                    </label>
                    <label class="cardfeild">
                      <span class="lbltext">{{'Total Refund Amount'|translate}}:</span>
                      <span class="lbldata policyno" style="color: red;">{{TravelRefundRes.TravelRefund.TotalRefundAmount}}</span>
                    </label>
                    <label class="cardfeild">
                      <span class="lbltext">{{'Refund Days'|translate}}:</span>
                      <span class="lbldata policyno" style="color: green;">{{TravelRefundRes.TravelRefund.RefundDays}} Days</span>
                    </label>
                    <label class="cardfeild">
                      <span class="lbltext">{{'Policy Used Days'|translate}}:</span>
                      <span class="lbldata policyno" style="color: green;">{{TravelRefundRes.TravelRefund.PolicyUsedDays}} Days</span>
                    </label>
                  </div> -->

                </div>
              </div>

              <div class="bordercardTravel" [ngStyle]="Direction()" style="padding: 20px;position: relative; background: white;">
                <form #TravelCancellation="ngForm">
                  <div class="row" style="display: flex;flex-wrap: wrap;justify-content: center;">
                    <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12 customCol">
                      <label class="lbltext">{{'Cancellation Date'| translate }}</label>
                      <input disabled type="date" class="form-control" id="txtCancellationDate" required name="txtCancellationDate" [(ngModel)]="objBindInfoRes.CancellationDate" #txtCancellationDate="ngModel">
                      <span *ngIf="txtCancellationDate.invalid && (txtCancellationDate.dirty || isSubmitted || txtCancellationDate.touched)" class="text-danger">
                        <div *ngIf="txtCancellationDate.errors?.required">
                          {{'Required'| translate }}
                        </div>
                      </span>
                    </div>
                    <div class="col-lg-7 col-md-7 col-sm-12 col-xs-12 customCol">
                      <label class="lbltext">{{'Cancellation Reason'| translate }}</label>
                      <select class="form-control" id="txtCancellationReason" selectRequired name="txtCancellationReason" (change)="CancellationReasonChange()" [(ngModel)]="objBindInfoRes.CancellationReason" #txtCancellationReason="ngModel">
                        <option disabled [value]=0>{{'Select Cancellation Reason'| translate }}</option>
                        <option *ngFor="let Reason of objBindInfoRes.CancellationReasonList" [value]="Reason.Code">
                          {{Lng=="en"?Reason.Description:Reason.Description_Ar}}</option>
                      </select>
                      <span *ngIf="txtCancellationReason.invalid && (txtCancellationReason.dirty || isSubmitted || txtCancellationReason.touched)" class="text-danger">
                        <div *ngIf="txtCancellationReason.errors?.selectRequired">
                          {{'Cancellation Reason is required'| translate }}
                        </div>
                      </span>
                    </div>
                   
                  
                    <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12 customCol">
                      <label class="lbltext">{{'Bank Name'| translate }}</label>
                      <select disabled required class="form-control" id="txtBankName" name="txtBankName" [(ngModel)]="objBindInfoRes.BankCode" #txtBankName="ngModel">
                        <option value="">--{{'Select Bank' |translate}}---</option>
                        <option *ngFor="let bank of objBindInfoRes.bankList" [value]="bank.BankCode">
                          {{Lng=="en"?bank.BankDesc_Eng:bank.BankDesc_Ar}}</option>
                      </select>
                      <span *ngIf="txtBankName.invalid && (txtBankName.dirty || isSubmitted || txtBankName.touched)" class="text-danger">
                        <div *ngIf="txtBankName.errors?.required">
                          {{'Bank is required'| translate }}
                        </div>
                      </span>
                    </div>
                    <div class="col-lg-7 col-md-7 col-sm-12 col-xs-12 customCol">
                      <label class="lbltext">{{'IBAN Number'| translate }}</label>
                      <div class="IBANholder">
                        <div class="col-lg-2 col-md-2 col-sm-4 col-xs-4 ibanboxdiv">
                          <div class="input-group groupItems">
                            <div class="input-group-addon">SA</div>
                            <input required type="text" class="form-control" id="txtIBAN1" numbersOnly name="txtIBAN1" [(ngModel)]="objBindInfoRes.IBAN1" maxlength="2" #txtIBAN1 [value]="txtIBAN1.value.toUpperCase()" (ngModelChange)="iban1Changed($event)" autocomplete="off" (keypress)="ValidateSpecialCharacters($event)" />
                          </div>
                        </div>
                        <div class="col-lg-2 col-md-2 col-sm-4 col-xs-4 ibanboxdiv">
                          <input required type="text" class="form-control" id="txtIBAN2" numbersOnly name="txtIBAN2" [(ngModel)]="objBindInfoRes.IBAN2" maxlength="4" (blur)="setBankCode(objBindInfoRes.IBAN2)" #txtIBAN2 [value]="txtIBAN2.value.toUpperCase()" (ngModelChange)="iban2Changed($event)" autocomplete="off" (keypress)="ValidateSpecialCharacters($event)" />
                        </div>
                        <div class="col-lg-2 col-md-2 col-sm-4 col-xs-4 ibanboxdiv">
                          <input required type="text" class="form-control" numbersOnly id="txtIBAN3" name="txtIBAN3" [(ngModel)]="objBindInfoRes.IBAN3" maxlength="4" #txtIBAN3 [value]="txtIBAN3.value.toUpperCase()" (ngModelChange)="iban3Changed($event)" autocomplete="off" (keypress)="ValidateSpecialCharacters($event)" />
                        </div>
                        <div class="col-lg-2 col-md-2 col-sm-4 col-xs-4 ibanboxdiv">
                          <input required type="text" class="form-control" id="txtIBAN4" numbersOnly name="txtIBAN4" [(ngModel)]="objBindInfoRes.IBAN4" maxlength="4" #txtIBAN4 [value]="txtIBAN4.value.toUpperCase()" (ngModelChange)="iban4Changed($event)" autocomplete="off" (keypress)="ValidateSpecialCharacters($event)" />
                        </div>
                        <div class="col-lg-2 col-md-2 col-sm-4 col-xs-4 ibanboxdiv">
                          <input required type="text" class="form-control" id="txtIBAN5" numbersOnly name="txtIBAN5" [(ngModel)]="objBindInfoRes.IBAN5" maxlength="4" #txtIBAN5 [value]="txtIBAN5.value.toUpperCase()" (ngModelChange)="iban5Changed($event)" autocomplete="off" (keypress)="ValidateSpecialCharacters($event)" />
                        </div>
                        <div class="col-lg-2 col-md-2 col-sm-4 col-xs-4 ibanboxdiv">
                          <input required type="text" class="form-control" id="txtIBAN6" numbersOnly name="txtIBAN6" [(ngModel)]="objBindInfoRes.IBAN6" maxlength="4" #txtIBAN6 [value]="txtIBAN6.value.toUpperCase()" autocomplete="off" (keypress)="ValidateSpecialCharacters($event)" />
                        </div>
                      </div>
                      <span class="text-danger">
                        <div>
                          *{{'IBAN Number must start with SA and enter 4 digits in each textbox(Ex:SA12 8056 7890 1234 6575 9898)'| translate }}
                        </div>
                      </span>
                    </div>

                    <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12 customCol">
                      <label class="lbltext">{{'Bank Holder Name'| translate }}</label>
                      <input class="form-control" (keypress)="allowEnglishOnly($event)" id="txtAccHolderName"
                      name="txtAccHolderName"
                        [(ngModel)]="objBindInfoRes.PolicyDetails.AccountName" type="text">
                      <small style="color: red; font-size: 12px;">
                        {{'NOTE: Name should contain English letters only'| translate }}
                      </small>
                
                    </div>
                    
                    <div *ngIf="objBindInfoRes.CancellationReason==12" class="col-lg-4 col-md-4 col-sm-12 col-xs-12 customCol ImageRow">
                      <label class="lbltext">{{'Visa Rejection'| translate }}</label>
                      <div class="panel panel-default">
                        <div class="panel-body">
                          <p class="text-center text-muted">
                            <i class="fa fa-camera fa-4x"></i>
                          </p>
                          <h4 class="text-center text-muted">
                            {{ 'Visa Rejection' | translate }}
                            <small uib-tooltip="For New Arrivals">
                              <i class="fa fa-info-circle"></i>
                            </small>
                            <br>
                            <small>({{ 'Scan Copy' | translate }} )</small>
                          </h4>
                          <div style="position:relative;">
                            <a class="btn btn-block" href='javascript:;'>
                              <b style="color:white;">{{ 'Choose File'| translate}}...</b>
                              <input type="file" (change)="ChooseFile($event,'VisaRejection')"  style='position:absolute; z-index: 2; top: 0; left: 0; filter: alpha(opacity=0); -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)"; opacity: 0; background-color: transparent; color: transparent;' size="10" accept="image/*" />
                            </a>
                            <img *ngIf="VisaRejection" (click)="OpenLarge(VisaRejection)" class="img-thumbnail imgdisplay" src="{{VisaRejection}}" height="75px">
                          </div>
                        </div>
                      </div>
                    </div>

                    <div *ngIf="objBindInfoRes.CancellationReason==14" class="col-lg-4 col-md-4 col-sm-12 col-xs-12 customCol ImageRow">
                      <label class="lbltext">{{'Other Force Majeure for trip Cancellation Copy'| translate }}</label>
                      <div class="panel panel-default">
                        <div class="panel-body">
                          <p class="text-center text-muted">
                            <i class="fa fa-camera fa-4x"></i>
                          </p>
                          <h4 class="text-center text-muted">
                            {{ 'Other Force Majeure for trip Cancellation Copy' | translate }}
                            <small uib-tooltip="For New Arrivals">
                              <i class="fa fa-info-circle"></i>
                            </small>
                            <br>
                            <small>({{ 'Scan Copy' | translate }} )</small>
                          </h4>
                          <div style="position:relative;">
                            <a class="btn btn-block" href='javascript:;'>
                              <b style="color:white;">{{ 'Choose File'| translate}}...</b>
                              <input type="file" (change)="ChooseFile($event,'WrongPolDet')"  style='position:absolute; z-index: 2; top: 0; left: 0; filter: alpha(opacity=0); -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)"; opacity: 0; background-color: transparent; color: transparent;' size="10" accept="image/*" />
                            </a>
                            <img *ngIf="WrongPolDet" (click)="OpenLarge(WrongPolDet)" class="img-thumbnail imgdisplay" src="{{WrongPolDet}}" height="75px">
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 customCol ImageRow">
                      <label class="lbltext">{{'IBAN Copy'| translate }}</label>
                      <div class="panel panel-default">
                        <div class="panel-body">
                          <p class="text-center text-muted">
                            <i class="fa fa-camera fa-4x"></i>
                          </p>
                          <h4 class="text-center text-muted">
                            {{ 'IBAN Copy' | translate }}
                            <small uib-tooltip="For New Arrivals">
                              <i class="fa fa-info-circle"></i>
                            </small>
                            <br>
                            <small>({{ 'Scan Copy' | translate }} )</small>
                          </h4>
                          <div style="position:relative;">
                            <a class="btn btn-block" href='javascript:;'>
                              <b style="color:white">{{ 'Choose File'| translate}}...</b>
                              <input type="file" (change)="ChooseFile($event,'IBANCopy')" style='position:absolute; z-index: 2; top: 0; left: 0; filter: alpha(opacity=0); -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)"; opacity: 0; background-color: transparent; color: transparent;' size="10" accept="image/*" />
                            </a>
                            <img *ngIf="IBANCopyURL" (click)="OpenLarge(IBANCopyURL)" class="img-thumbnail imgdisplay" src="{{IBANCopyURL}}" height="75px">
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </form>

                <div style="display: flex;justify-content:center;">
                  <button [disabled]="isLockFields==true||TravelCancellation.invalid" (click)="SendOtpCanellation()" class="btn btn-primary">{{'Submit'| translate }}</button>
                </div>

                <div class="Field OTPForm" *ngIf="showOTP">
                  <div class="row">
                      <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                          <label class="Verifi">{{'Verification Code'|translate}}</label>
                      </div>
                      <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
                          <div class="row">
                              <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                  <input type="text" class="form-control" numbersOnly
                                      (keypress)="ValidateSpecialChar($event)" maxlength="6"
                                      [(ngModel)]="OTP">
                              </div>
                              <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 btnsblock">
                                  <button type="button" class="btn btn-primary Resend verifybtn"
                                      (click)="VerifyOTP()">{{'Verify'|translate}}</button>
                                  <button *ngIf="isResendShow" type="button"
                                      class="btn btn-primary Resend resendbtn"
                                      (click)="SendOTP()">{{'Resend'|translate}}</button>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="Field" *ngIf="isShowTimer" style="margin-top:20px;">
                  <span class="quotelink">{{'You can Resend OTP in '}} {{ timeLeft }}
                      {{'Seconds'}}</span>
              </div>


              </div>
              
            </div> 
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/TravelPortal/TravelCancellation/TravelCancellation.html